const _temp0 = require("./_shared/layout/default.view.less");



const _temp1 = require("./login/request/request.view.less");



const _temp2 = require("./logout/success/success.view.less");



module.exports = {
  "_shared":   {
    "layout":     {
      "default":       {
        "less": _temp0
      }
    }
  },
  "login":   {
    "request":     {
      "request":       {
        "less": _temp1
      }
    }
  },
  "logout":   {
    "success":     {
      "success":       {
        "less": _temp2
      }
    }
  }
}